export const getContactBookGetter = state => {
  return state.contactBook
}

export const getContactGroupsGetter = state => {
  return state.contactGroups
}
